<!--  -->
<template>
  <div class="search_box">
    <el-form
      ref="form"
      label-width="120px"
    >
      <el-form-item
        prop="code"
        label="选择员工"
      >
        <el-tag
          v-for="(items, index) in corp_userid"
          :key="index"
          style="margin-right: 10px"
          closable
          @close="handleClose(index)"
        >{{ items.name }}({{ items.corp_name }})
        </el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="chorwe"
        >选择企业员工</el-button>
      </el-form-item>
      <el-form-item
        prop="description"
        label="自定义参数"
      >
        <el-input v-model="channel_type" />
      </el-form-item>
      <el-form-item
        prop="code"
        label="备注"
      >
        <el-input v-model="remark" />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="sunwewr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>

<script>
import { spWorkWechatSpCorpUserQrcodeCreate } from '@/api/QRcode'
import bandstaff from './bandstaff.vue'
export default {
  components: { bandstaff },
  data() {
    return {
      channel_type: '',
      remark: '',
      corp_userid: [],
      allcorp_userid: [],
      dialogVisibler: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    sunwewr() {
      console.log('this.corp_userid', this.corp_userid)
      if (this.corp_userid.length === 0) {
        this.$message({
          message: '请选择员工',
          type: 'error'
        })
        return
      }
      this.allcorp_userid = []
      this.allcorp_userid = this.corp_userid.map(item => {
        return item.user_id
      })
      spWorkWechatSpCorpUserQrcodeCreate({
        remark: this.remark,
        channel_type: this.channel_type,
        user_ids: this.allcorp_userid
      }).then(res => {
        console.log('res', res)
        this.$emit('updata')
      })
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr('', this.corp_userid)
      })
    },
    async bandarr(arr) {
      this.dialogVisibler = false
      this.corp_userid = arr
      console.log(arr)
    },
    handleClose(index) {
      this.corp_userid.splice(index, 1)
    }
  }
}
</script>
<style scoped>
</style>
